const granules = [{
    coord: [
        [44, 20],
        [45, 21],
    ],
    text: "",
    coordaltmax: [44.12, 20.02],
    coordaltmin: [44.43, 20.32],
    altmax: 1074,
    altmin: 35,
    altmed: 554.5,
    image: "/resources/N44E020.png",
    image3d: "/resources/N44E020_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 1,
}, {
    coord: [
        [44, 21],
        [45, 22],
    ],
    text: "",
    coordaltmax: [44.12, 21.71],
    coordaltmin: [44.71, 21.23],
    altmax: 1316,
    altmin: 32,
    altmed: 674.0,
    image: "/resources/N44E021.png",
    image3d: "/resources/N44E021_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 2,
}, {
    coord: [
        [44, 22],
        [45, 23],
    ],
    text: "",
    coordaltmax: [44.98, 22.54],
    coordaltmin: [44.2, 22.78],
    altmax: 1294,
    altmin: 28,
    altmed: 661.0,
    image: "/resources/N44E022.png",
    image3d: "/resources/N44E022_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 3,
}, {
    coord: [
        [44, 23],
        [45, 24],
    ],
    text: "",
    coordaltmax: [44.99, 23.92],
    coordaltmin: [44.07, 23.06],
    altmax: 542,
    altmin: 29,
    altmed: 285.5,
    image: "/resources/N44E023.png",
    image3d: "/resources/N44E023_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 4,
}, {
    coord: [
        [44, 24],
        [45, 25],
    ],
    text: "",
    coordaltmax: [44.99, 24.53],
    coordaltmin: [44.01, 24.64],
    altmax: 524,
    altmin: 49,
    altmed: 286.5,
    image: "/resources/N44E024.png",
    image3d: "/resources/N44E024_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 5,
}, {
    coord: [
        [44, 25],
        [45, 26],
    ],
    text: "",
    coordaltmax: [44.99, 25.22],
    coordaltmin: [44.01, 25.41],
    altmax: 517,
    altmin: 46,
    altmed: 281.5,
    image: "/resources/N44E025.png",
    image3d: "/resources/N44E025_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 6,
}, {
    coord: [
        [44, 26],
        [45, 27],
    ],
    text: "",
    coordaltmax: [44.99, 26.19],
    coordaltmin: [44.18, 26.92],
    altmax: 335,
    altmin: 5,
    altmed: 170.0,
    image: "/resources/N44E026.png",
    image3d: "/resources/N44E026_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Vertisol",
        coord: [44.1833, 26.9667],
        dataset: "date SMAP"
    }],
    soilRes: [],
    granuleNumber: 7,
}, {
    coord: [
        [44, 27],
        [45, 28],
    ],
    text: "",
    coordaltmax: [44.01, 27.74],
    coordaltmin: [44.84, 27.89],
    altmax: 201,
    altmin: -4,
    altmed: 98.5,
    image: "/resources/N44E027.png",
    image3d: "/resources/N44E027_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 8,
}, {
    coord: [
        [44, 28],
        [45, 29],
    ],
    text: "",
    coordaltmax: [44.86, 28.42],
    coordaltmin: [44.54, 28.84],
    altmax: 381,
    altmin: -6,
    altmed: 187.5,
    image: "/resources/N44E028.png",
    image3d: "/resources/N44E028_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 9,
}, {
    coord: [
        [44, 29],
        [45, 30],
    ],
    text: "",
    coordaltmax: [44.99, 29.15],
    coordaltmin: [44.83, 29.53],
    altmax: 55,
    altmin: -5,
    altmed: 25.0,
    image: "/resources/N44E029.png",
    image3d: "/resources/N44E029_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 10,
}, {
    coord: [
        [45, 20],
        [46, 21],
    ],
    text: "",
    coordaltmax: [45.16, 20.2],
    coordaltmin: [45.39, 20.36],
    altmax: 228,
    altmin: 49,
    altmed: 138.5,
    image: "/resources/N45E020.png",
    image3d: "/resources/N45E020_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 11,
}, {
    coord: [
        [45, 21],
        [46, 22],
    ],
    text: "",
    coordaltmax: [45.08, 21.99],
    coordaltmin: [45.11, 21.1],
    altmax: 1056,
    altmin: 70,
    altmed: 563.0,
    image: "/resources/N45E021.png",
    image3d: "/resources/N45E021_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 12,
}, {
    coord: [
        [45, 22],
        [46, 23],
    ],
    text: "",
    coordaltmax: [45.38, 22.85],
    coordaltmin: [45.83, 22.01],
    altmax: 2452,
    altmin: 123,
    altmed: 1287.5,
    image: "/resources/N45E022.png",
    image3d: "/resources/N45E022_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Plumb",
        coord: [45.4, 22.8],
        dataset: "date Landsat 8"
    },],
    soilRes: [],
    granuleNumber: 13,
}, {
    coord: [
        [45, 23],
        [46, 24],
    ],
    text: "",
    coordaltmax: [45.34, 23.54],
    coordaltmin: [45.01, 23.2],
    altmax: 2501,
    altmin: 177,
    altmed: 1339.0,
    image: "/resources/N45E023.png",
    image3d: "/resources/N45E023_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 14,
}, {
    coord: [
        [45, 24],
        [46, 25],
    ],
    text: "",
    coordaltmax: [45.58, 24.83],
    coordaltmin: [45.01, 24.28],
    altmax: 2463,
    altmin: 205,
    altmed: 1334.0,
    image: "/resources/N45E024.png",
    image3d: "/resources/N45E024_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 15,
}, {
    coord: [
        [45, 25],
        [46, 26],
    ],
    text: "",
    coordaltmax: [45.43, 25.48],
    coordaltmin: [45.04, 25.99],
    altmax: 2402,
    altmin: 202,
    altmed: 1302.0,
    image: "/resources/N45E025.png",
    image3d: "/resources/N45E025_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Chernozem",
        coord: [45.2167, 25.7500],
        dataset: "SMAP data"
    }, {
        type: "Uraniu",
        coord: [46, 25.5],
        dataset: "date Landsat 8"
    }],
    soilRes: [],
    granuleNumber: 16,
}, {
    coord: [
        [45, 26],
        [46, 27],
    ],
    text: "",
    coordaltmax: [45.8, 26.42],
    coordaltmin: [45.09, 26.99],
    altmax: 1739,
    altmin: 57,
    altmed: 898.0,
    image: "/resources/N45E026.png",
    image3d: "/resources/N45E026_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 17,
}, {
    coord: [
        [45, 27],
        [46, 28],
    ],
    text: "",
    coordaltmax: [45.74, 27.01],
    coordaltmin: [45.05, 27.98],
    altmax: 579,
    altmin: -2,
    altmed: 288.5,
    image: "/resources/N45E027.png",
    image3d: "/resources/N45E027_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 18,
}, {
    coord: [
        [45, 28],
        [46, 29],
    ],
    text: "",
    coordaltmax: [45.2, 28.28],
    coordaltmin: [45.46, 28.32],
    altmax: 410,
    altmin: -4,
    altmed: 203.0,
    image: "/resources/N45E028.png",
    image3d: "/resources/N45E028_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 19,
}, {
    coord: [
        [45, 29],
        [46, 30],
    ],
    text: "",
    coordaltmax: [45.09, 29.04],
    coordaltmin: [45.12, 29.23],
    altmax: 196,
    altmin: -8,
    altmed: 94.0,
    image: "/resources/N45E029.png",
    image3d: "/resources/N45E029_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 20,
}, {
    coord: [
        [46, 20],
        [47, 21],
    ],
    text: "",
    coordaltmax: [46.29, 20.92],
    coordaltmin: [46.92, 20.38],
    altmax: 110,
    altmin: 66,
    altmed: 88.0,
    image: "/resources/N46E020.png",
    image3d: "/resources/N46E020_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 21,
}, {
    coord: [
        [46, 21],
        [47, 22],
    ],
    text: "",
    coordaltmax: [46.2, 21.81],
    coordaltmin: [46.62, 21.16],
    altmax: 737,
    altmin: 75,
    altmed: 406.0,
    image: "/resources/N46E021.png",
    image3d: "/resources/N46E021_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 22,
}, {
    coord: [
        [46, 22],
        [47, 23],
    ],
    text: "",
    coordaltmax: [46.44, 22.69],
    coordaltmin: [46.45, 22.02],
    altmax: 1829,
    altmin: 116,
    altmed: 972.5,
    image: "/resources/N46E022.png",
    image3d: "/resources/N46E022_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 23,
}, {
    coord: [
        [46, 23],
        [47, 24],
    ],
    text: "",
    coordaltmax: [46.49, 23.24],
    coordaltmin: [46.01, 23.5],
    altmax: 1817,
    altmin: 211,
    altmed: 1014.0,
    image: "/resources/N46E023.png",
    image3d: "/resources/N46E023_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Luvisol",
        coord: [46.75, 23.5],
        dataset: "date MODIS"
    }, {
        type: "Aur",
        coord: [46.55, 23.35],
        dataset: "date Landsat 8"
    }, {
        type: "Argint",
        coord: [47.2, 23.8],
        dataset: "date Landsat 8"
    }],
    soilRes: [],
    granuleNumber: 24,
}, {
    coord: [
        [46, 24],
        [47, 25],
    ],
    text: "",
    coordaltmax: [46.88, 24.97],
    coordaltmin: [46.13, 24.01],
    altmax: 1279,
    altmin: 253,
    altmed: 766.0,
    image: "/resources/N46E024.png",
    image3d: "/resources/N46E024_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Cupru",
        coord: [46.1, 24.35],
        dataset: "date Landsat 8"
    }],
    soilRes: [],
    granuleNumber: 25,
}, {
    coord: [
        [46, 25],
        [47, 26],
    ],
    text: "",
    coordaltmax: [46.96, 25.94],
    coordaltmin: [46.27, 25.01],
    altmax: 1794,
    altmin: 381,
    altmed: 1087.5,
    image: "/resources/N46E025.png",
    image3d: "/resources/N46E025_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 26,
}, {
    coord: [
        [46, 26],
        [47, 27],
    ],
    text: "",
    coordaltmax: [46.64, 26.16],
    coordaltmin: [46.4, 26.99],
    altmax: 1644,
    altmin: 122,
    altmed: 883.0,
    image: "/resources/N46E026.png",
    image3d: "/resources/N46E026_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 27,
}, {
    coord: [
        [46, 27],
        [47, 28],
    ],
    text: "",
    coordaltmax: [46.54, 27.28],
    coordaltmin: [46.99, 27.98],
    altmax: 536,
    altmin: 25,
    altmed: 280.5,
    image: "/resources/N46E027.png",
    image3d: "/resources/N46E027_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 28,
}, {
    coord: [
        [46, 28],
        [47, 29],
    ],
    text: "",
    coordaltmax: [46.66, 28.02],
    coordaltmin: [46.08, 28.13],
    altmax: 365,
    altmin: 4,
    altmed: 184.5,
    image: "/resources/N46E028.png",
    image3d: "/resources/N46E028_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 29,
}, {
    coord: [
        [46, 29],
        [47, 30],
    ],
    text: "",
    coordaltmax: [46.6, 29.01],
    coordaltmin: [46.53, 29.94],
    altmax: 245,
    altmin: -4,
    altmed: 120.5,
    image: "/resources/N46E029.png",
    image3d: "/resources/N46E029_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 30,
}, {
    coord: [
        [47, 20],
        [48, 21],
    ],
    text: "",
    coordaltmax: [47.87, 20.01],
    coordaltmin: [47.75, 20.14],
    altmax: 983,
    altmin: 44,
    altmed: 513.5,
    image: "/resources/N47E020.png",
    image3d: "/resources/N47E020_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 31,
}, {
    coord: [
        [47, 21],
        [48, 22],
    ],
    text: "",
    coordaltmax: [47.06, 21.99],
    coordaltmin: [47.15, 21.03],
    altmax: 261,
    altmin: 75,
    altmed: 168.0,
    image: "/resources/N47E021.png",
    image3d: "/resources/N47E021_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Cambisol",
        coord: [47.17, 21.17],
        dataset: "date MODIS"
    }],
    soilRes: [],
    granuleNumber: 32,
}, {
    coord: [
        [47, 22],
        [48, 23],
    ],
    text: "",
    coordaltmax: [47.01, 22.91],
    coordaltmin: [47.3, 22.01],
    altmax: 935,
    altmin: 99,
    altmed: 517.0,
    image: "/resources/N47E022.png",
    image3d: "/resources/N47E022_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Zinc",
        coord: [47.5, 23],
        dataset: "date Landsat 8"
    },],
    soilRes: [],
    granuleNumber: 33,
}, {
    coord: [
        [47, 23],
        [48, 24],
    ],
    text: "",
    coordaltmax: [47.7, 23.84],
    coordaltmin: [47.98, 23.03],
    altmax: 1377,
    altmin: 121,
    altmed: 749.0,
    image: "/resources/N47E023.png",
    image3d: "/resources/N47E023_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Argint",
        coord: [47.2, 23.8],
        dataset: "date Landsat 8"
    }],
    soilRes: [],
    granuleNumber: 34,
}, {
    coord: [
        [47, 24],
        [48, 25],
    ],
    text: "",
    coordaltmax: [47.6, 24.63],
    coordaltmin: [47.17, 24.01],
    altmax: 2156,
    altmin: 238,
    altmed: 1197.0,
    image: "/resources/N47E024.png",
    image3d: "/resources/N47E024_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 35,
}, {
    coord: [
        [47, 25],
        [48, 26],
    ],
    text: "",
    coordaltmax: [47.12, 25.19],
    coordaltmin: [47.99, 25.99],
    altmax: 2039,
    altmin: 331,
    altmed: 1185.0,
    image: "/resources/N47E025.png",
    image3d: "/resources/N47E025_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 36,
}, {
    coord: [
        [47, 26],
        [48, 27],
    ],
    text: "",
    coordaltmax: [47.01, 26.14],
    coordaltmin: [47.51, 26.99],
    altmax: 1161,
    altmin: 69,
    altmed: 615.0,
    image: "/resources/N47E026.png",
    image3d: "/resources/N47E026_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 37,
}, {
    coord: [
        [47, 27],
        [48, 28],
    ],
    text: "",
    coordaltmax: [47.01, 27.36],
    coordaltmin: [47.01, 27.99],
    altmax: 449,
    altmin: 24,
    altmed: 236.5,
    image: "/resources/N47E027.png",
    image3d: "/resources/N47E027_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 38,
}, {
    coord: [
        [47, 28],
        [48, 29],
    ],
    text: "",
    coordaltmax: [47.28, 28.03],
    coordaltmin: [47.13, 28.97],
    altmax: 404,
    altmin: 21,
    altmed: 212.5,
    image: "/resources/N47E028.png",
    image3d: "/resources/N47E028_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 39,
}, {
    coord: [
        [47, 29],
        [48, 30],
    ],
    text: "",
    coordaltmax: [47.98, 29.26],
    coordaltmin: [47.01, 29.34],
    altmax: 272,
    altmin: 8,
    altmed: 140.0,
    image: "/resources/N47E029.png",
    image3d: "/resources/N47E029_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 40,
}, {
    coord: [
        [48, 20],
        [49, 21],
    ],
    text: "",
    coordaltmax: [48.88, 20.14],
    coordaltmin: [48.01, 20.92],
    altmax: 1851,
    altmin: 97,
    altmed: 974.0,
    image: "/resources/N48E020.png",
    image3d: "/resources/N48E020_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 41,
}, {
    coord: [
        [48, 21],
        [49, 22],
    ],
    text: "",
    coordaltmax: [48.78, 21.02],
    coordaltmin: [48.05, 21.11],
    altmax: 1064,
    altmin: 86,
    altmed: 575.0,
    image: "/resources/N48E021.png",
    image3d: "/resources/N48E021_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 42,
}, {
    coord: [
        [48, 22],
        [49, 23],
    ],
    text: "",
    coordaltmax: [48.8, 22.81],
    coordaltmin: [48.22, 22.02],
    altmax: 1475,
    altmin: 92,
    altmed: 783.5,
    image: "/resources/N48E022.png",
    image3d: "/resources/N48E022_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 43,
}, {
    coord: [
        [48, 23],
        [49, 24],
    ],
    text: "",
    coordaltmax: [48.6, 23.91],
    coordaltmin: [48.01, 23.01],
    altmax: 1709,
    altmin: 121,
    altmed: 915.0,
    image: "/resources/N48E023.png",
    image3d: "/resources/N48E023_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 44,
}, {
    coord: [
        [48, 24],
        [49, 25],
    ],
    text: "",
    coordaltmax: [48.16, 24.5],
    coordaltmin: [48.97, 24.99],
    altmax: 2044,
    altmin: 197,
    altmed: 1120.5,
    image: "/resources/N48E024.png",
    image3d: "/resources/N48E024_3dless_com_simplified_render.png",
    soilComp: [{
        type: "Podzol",
        coord: [48.0003, 23.9997],
        dataset: "date MODIS"
    }],
    soilRes: [],
    granuleNumber: 45,
}, {
    coord: [
        [48, 25],
        [49, 26],
    ],
    text: "",
    coordaltmax: [48.05, 25.18],
    coordaltmin: [48.62, 25.99],
    altmax: 1259,
    altmin: 131,
    altmed: 695.0,
    image: "/resources/N48E025.png",
    image3d: "/resources/N48E025_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 46,
}, {
    coord: [
        [48, 26],
        [49, 27],
    ],
    text: "",
    coordaltmax: [48.05, 26.06],
    coordaltmin: [48.16, 26.95],
    altmax: 450,
    altmin: 90,
    altmed: 270.0,
    image: "/resources/N48E026.png",
    image3d: "/resources/N48E026_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 47,
}, {
    coord: [
        [48, 27],
        [49, 28],
    ],
    text: "",
    coordaltmax: [48.98, 27.79],
    coordaltmin: [48.59, 27.46],
    altmax: 373,
    altmin: 54,
    altmed: 213.5,
    image: "/resources/N48E027.png",
    image3d: "/resources/N48E027_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 48,
}, {
    coord: [
        [48, 28],
        [49, 29],
    ],
    text: "",
    coordaltmax: [48.12, 28.07],
    coordaltmin: [48.01, 28.58],
    altmax: 345,
    altmin: 28,
    altmed: 186.5,
    image: "/resources/N48E028.png",
    image3d: "/resources/N48E028_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 49,
}, {
    coord: [
        [48, 29],
        [49, 30],
    ],
    text: "",
    coordaltmax: [48.98, 29.21],
    coordaltmin: [48.12, 29.98],
    altmax: 308,
    altmin: 93,
    altmed: 200.5,
    image: "/resources/N48E029.png",
    image3d: "/resources/N48E029_3dless_com_simplified_render.png",
    soilComp: [],
    soilRes: [],
    granuleNumber: 50,
},]




export default granules;